import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pages/field-notes")({
  beforeLoad: () => {
    throw redirect({ to: "/field-notes", statusCode: 301 });
  },
});
